import {IDataDto, IDataNoPageDto} from "@models/shared/IDataDto.ts";
import {IApiEndpoint} from "@localization/siteMap/siteMapInterfaces.ts";
import {IRole} from "@models/roles/roles.ts";
import {RoleIncludable, RoleOrderable} from "@models/roles/roleTypes.ts";
import {IGetRolesFilter} from "@models/roles/IGetRolesFilter.ts";
import {IOrder} from "@models/shared/IOrder.ts";
import {ICreateRoleDto} from "@models/roles/ICreateRoleDto.ts";
import {IChangeRoleMembro} from "@models/roles/IChangeRoleMembro.ts";
import {IPermissao, PermissaoAplicacao} from "@models/seguranca/permissaoApp.ts";
import {IDuplicaRoleDto} from "@components/roles/models/IDuplicaRoleDto.ts";

const v2prefix = '/api/v2/roles';

export const __roles_endpoints = {
    ['v2']: {
        prefix: '/api/v2/roles',
        ['get-role']: function (data: IDataNoPageDto<{ id: number }, RoleIncludable[] | undefined>) {
            return {
                url: `${v2prefix}/${data['data']['id']}`,
                method: 'GET',
                data: {...data}
            } as IApiEndpoint<IRole>
        },
        ['get-roles']: function (data: IDataDto<IGetRolesFilter, RoleIncludable[] | undefined, IOrder<RoleOrderable[]> | undefined>) {
            return {
                url: `${v2prefix}`,
                method: 'GET',
                data: data
            } as IApiEndpoint<IRole[]>
        },
        ['create-role']: function (data: IDataNoPageDto<ICreateRoleDto>) {
            return {
                url: `${v2prefix}`,
                method: 'POST',
                body: data
            } as IApiEndpoint<IRole>
        },
        ['import-roles']: function (data: IDataNoPageDto<ICreateRoleDto[]>) {
            return {
                url: `${v2prefix}/import`,
                method: 'POST',
                body: data
            } as IApiEndpoint<IRole[]>
        },
        ['add-role-membro']: function (data: IDataNoPageDto<IChangeRoleMembro>) {
            return {
                url: `${v2prefix}/${data['data']['roleId']}/membros/${data['data']['usuarioId']}`,
                method: 'POST',
                body: data
            } as IApiEndpoint<IRole>
        },
        ['remove-role-membro']: function (data: IDataNoPageDto<IChangeRoleMembro>) {
            return {
                url: `${v2prefix}/${data['data']['roleId']}/membros/${data['data']['usuarioId']}`,
                method: 'DELETE',
                body: data
            } as IApiEndpoint
        },
        ['get-permissoes']: function (data: IDataDto<{ roleId: number }>) {
            return {
                url: `/api/v2/Roles/${data.data.roleId}/permissoes`,
                data: data,
                method: 'GET',
            } as IApiEndpoint<IPermissao[]>
        },
        ['add-permissao']: function (data: IDataNoPageDto<{ roleId: number, permissoes: PermissaoAplicacao[] }>) {
            return {
                url: `/api/v2/Roles/${data.data.roleId}/permissoes`,
                data: {
                    data: [...data.data.permissoes]
                },
                method: 'POST',
            } as IApiEndpoint
        },
        ['remove-permissao']: function (data: IDataNoPageDto<{ roleId: number, permissoes: PermissaoAplicacao[] }>) {
            return {
                url: `/api/v2/Roles/${data.data.roleId}/permissoes`,
                data: {
                    data: [...data.data.permissoes]
                },
                method: 'DELETE',
            } as IApiEndpoint
        },
        ['duplica-role']: function (data: IDataNoPageDto<IDuplicaRoleDto>) {
            const {idRole, ...rest} = data.data
            return {
                url: `${v2prefix}/${idRole}/duplicar`,
                data: {...data, data: rest},
                method: 'POST'
            } as IApiEndpoint<IRole>
        }
    }
}